export default "__VITE_ASSET__C9oYH6nB__"